import { render, staticRenderFns } from "./HistoryMainView.vue?vue&type=template&id=12d18066"
import script from "./HistoryMainView.vue?vue&type=script&lang=ts"
export * from "./HistoryMainView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports